<div class="content">
  <div class="content-panel">
    <h2 translate>page.auth.no-roles.title</h2>
    <div>{{'page.auth.no-roles.message.'+typeUtilisateur | translate}}</div>
  </div>
</div>
